import 'regenerator-runtime/runtime';

import Helmet from '@plone/volto/helpers/Helmet/Helmet';
import { GoogleStructuredData } from 'govbr.frontend.policy/components';

const HtmlHeader = () => (
  <>
    <Helmet>
      {/* =========================
         Rawline Font (não bloqueante)
         ========================= */}
      <link
        rel="preload"
        href={
          'https://barra.sistema.gov.br/v1/fonts/rawline/css/rawline.css'
        }
        as="style"
        onLoad="this.rel='stylesheet'"
      />
      {/* =========================
         Font Awesome (deferido)
         ========================= */}
      <link
        rel="preload"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.2/css/all.min.css"
        as="style"
        crossOrigin="anonymous"
        referrerPolicy="no-referrer"
        onLoad="this.rel='stylesheet'"
      />
      {/* =========================
         Barra GovBR (não bloqueia render)
         ========================= */}
      <script
        type="module"
        id="barra-govbr-js"
        src="https://barra.sistema.gov.br/v1/barra-govbr-wc.js"
        defer
      />
    </Helmet>
    <GoogleStructuredData />
  </>
);

export default HtmlHeader;
